import { QuestionFilled } from "@aircall/icons";
import { Button, Tooltip } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { useHandler } from "./HelpButton.hooks";

const DELAY = 200;

export function HelpButton() {
  const { t } = useTranslation();
  const handleOnClick = useHandler();

  return (
    <Tooltip mouseEnterDelay={DELAY} title={t("help_center")}>
      <Button
        data-test="help-button"
        onClick={handleOnClick}
        variant="secondary"
        mode="ghost"
        size="small"
      >
        <QuestionFilled />
      </Button>
    </Tooltip>
  );
}
